import { ReactNode } from 'react'
import { Icon, Spacer } from '@vinted/web-ui'

type Props = {
  children: ReactNode
  iconName: React.ComponentProps<typeof Icon>['name']
  truncate?: boolean
}

const UserInfoLine = ({ children, iconName, truncate }: Props) => (
  <div className="u-flexbox u-align-items-baseline">
    <Icon name={iconName} color="greyscale-level-2" aria={{ 'aria-hidden': 'true' }} />
    <Spacer orientation="vertical" />
    <div className={truncate ? 'u-ellipsis' : ''}>{children}</div>
  </div>
)

export default UserInfoLine
